// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__O_0Fr","col":"styles_col__1IvPS"};